'use strict';
const _ = require('underscore');
const i18n = require('i18next');
const Notification = require('../index');

module.exports = Notification.extend({
    defaults: {
        sender: null,
        project: null,
        message: null,
        eventAt: null,
        version: 2
    },

    getTaskName() {
        return this.get('message').after.name;
    },

    getTaskID() {
        return this.get('message').after.id;
    },

    getProjectName() {
        return this.get('project').name;
    },

    getProjectID() {
        return this.get('project').id;
    },

    getTitle: function() {
        return this.getTaskName();
    },

    getIconClass: function() {
        return 'fa fa-check-square text-primary';
    },

    getSender: function() {
        return this.get('sender');
    },

    getSubTitle: function() {
        return `in ${this.getProjectName()}`;
    },

    getContent: function() {
        const keys = _.keys(this.get('message').changes);
        if(_.contains(keys, 'state')) {
            const state = this.get('message').changes.state.after;
            return i18n.t('notification:task.state_change.content', {
                state_name: i18n.t(`communication:task.state.${state}`)
            });
        } else {
            return i18n.t('notification:task.update.content');
        }
    },

    getLinkURL: function() {
        return `/projects/${this.getProjectID()}#/tasks/${this.getTaskID()}`
    }
}, {
    type: 'task:update'
});



// WEBPACK FOOTER //
// ./notify/domain/entity/notification/task/update.js